module.exports = __webpack_public_path__ + "static/img/background.fa242f3b.svg";